(function ($) {
    $(document).ready(() => {
        if ($('header').hasClass('site-header')) {
            const burger = $('.header-burger');
            const navigation = $('.header-menu');
            const body = $('body');
            const currentUrl = window.location.href;

            // Инициализация
            initHamburger(burger, navigation, body);
            preventCurrentUrlNavigation(currentUrl);
            preventSubMenuClickPropagation();
        }
    });

    // Функция для переключения состояний гамбургера и навигации
    const initHamburger = (burger, navigation, body) => {
        burger.click(() => {
            burger.toggleClass("active");
            navigation.toggleClass("active");
            body.toggleClass('active');
        });
    };

    // Функция для предотвращения перехода по текущему URL
    const preventCurrentUrlNavigation = (currentUrl) => {
        $('.menu-item a').click((event) => {
            const linkUrl = $(event.currentTarget).attr('href');
            if (linkUrl === currentUrl) {
                event.preventDefault();
            }
        });
    };

    // Функция для предотвращения всплытия события на подменю
    const preventSubMenuClickPropagation = () => {
        $('.menu-item-has-children > .sub-menu').click((event) => {
            event.stopPropagation();
        });
    };
})(jQuery);
